export function setChildren(state, value) {
  state.children = value;
}
